import React from 'react';

/**
 * Build credit, shown in every footer.
 *
 * Defined once so the wording and the new-tab attributes cannot drift between
 * the eight places it appears. `rel="noopener"` matters on a target="_blank"
 * link: without it the opened page gets a handle back into this one.
 */
const SiteCredit = ({ tone = 'light', className = '' }) => {
  const text = tone === 'dark' ? 'text-brand-100/60' : 'text-ink-500';
  const link =
    tone === 'dark'
      ? 'text-gold-400 hover:text-gold-300'
      : 'text-brand-700 hover:text-brand-800';

  return (
    <p className={`text-xs ${text} ${className}`}>
      Designed and developed by{' '}
      <a
        href="https://zenpixl.com"
        target="_blank"
        rel="noopener noreferrer"
        className={`font-600 underline underline-offset-2 transition-colors ${link}`}
      >
        zenpixl.com
      </a>
    </p>
  );
};

export default SiteCredit;
